import React from 'react';
import { Trophy, Users, Plus } from 'lucide-react';

const LeaderboardList = ({ leaderboards, selectedId, onSelect, onCreate }) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider font-rasa">My Leaderboards</h3>
        <button
          onClick={onCreate}
          className="p-1.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          title="Create Leaderboard"
        >
          <Plus size={14} />
        </button>
      </div>

      {leaderboards.length === 0 ? (
        <div className="bg-gray-50 p-4 rounded-lg text-center">
          <Trophy size={24} className="mx-auto mb-2 text-gray-300" />
          <p className="text-sm text-gray-500 font-rasa">No leaderboards yet</p>
          <button
            onClick={onCreate}
            className="mt-2 text-sm text-blue-500 hover:text-blue-700 font-rasa"
          >
            Create your first one
          </button>
        </div>
      ) : (
        <div className="space-y-1">
          {leaderboards.map(lb => (
            <button
              key={lb.id}
              onClick={() => onSelect(lb.id)}
              className={`w-full text-left px-3 py-2.5 rounded-lg transition-colors flex items-center gap-2 ${
                selectedId === lb.id
                  ? 'bg-blue-50 text-blue-700 border border-blue-200'
                  : 'hover:bg-gray-50 dark:text-gray-300 text-gray-700'
              }`}
            >
              <Trophy size={14} className={selectedId === lb.id ? 'text-blue-500' : 'text-gray-400'} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium font-rasa truncate">{lb.name}</p>
                <p className="text-xs text-gray-400 font-rasa flex items-center gap-1">
                  <Users size={10} /> {lb.member_count} members
                  {lb.is_owner && <span className="text-blue-500 ml-1">owner</span>}
                </p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LeaderboardList;
